import { render, staticRenderFns } from "./ContentDatabase.vue?vue&type=template&id=3cd4b92a&scoped=true"
import script from "./ContentDatabase.vue?vue&type=script&lang=js"
export * from "./ContentDatabase.vue?vue&type=script&lang=js"
import style0 from "./ContentDatabase.vue?vue&type=style&index=0&id=3cd4b92a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4b92a",
  null
  
)

export default component.exports